<template>
  <div
    style="position: relative;"
    @dragover="log('drag!')"
    :class="{
      dragged: dragging && isDraggingSelf,
      'first-block': index == 0,
      'h1-block': note.type == 'note' && blockType == 'h1',
      'h2-block': note.type == 'note' && blockType == 'h2'
    }"
  >
    <v-layout
      :class="`noteBlock ${dragSelected ? 'blue lighten-4' : ''}`"
      @mouseenter.stop="
        !animating && !dragSelecting
          ? (hovering = true)
          : dragSelecting
          ? $emit('selectMouseEnter', note)
          : null
      "
      @mouseleave="handleMouseLeave"
      @mousedown.left.stop="testDragSelectStart"
      @mouseup.left="stopDragSelect"
      @click.stop="note.type != 'card' ? $emit('clearDragSelection') : null"
    >
      <note-block-drop-helper
        v-if="userCanEdit"
        :item="note"
        :pageNotes="pageNotes"
        :pageId="pageId"
        :showDoc="show"
      ></note-block-drop-helper>
      <v-flex>
        <v-menu v-if="userCanEdit && !show" left v-model="noteBlockMenu" offset-y>
          <template v-slot:activator="{ on: { click } }">
            <v-btn
              :icon="!firstDragSelected"
              x-small
              class="mx-0 my-0"
              :fab="firstDragSelected"
              :color="firstDragSelected ? 'primary' : ''"
              :style="
                `height: 26px; width: 26px; position: absolute; left: ${
                  note.type == 'card' ? '-24' : '-24'
                }px; top: 4px;`
              "
              :disabled="dragging"
              @mousedown.stop
              @dragstart.stop="dragStart"
              draggable
              @click.stop="click"
            >
              <v-icon
                v-show="firstDragSelected || (hovering && (!dragging || isDraggingSelf))"
                :color="firstDragSelected ? 'white' : 'grey lighten-1'"
                >drag_indicator</v-icon
              >
            </v-btn>
            <!-- <v-btn icon small v-on="on">
              <v-icon>more_horiz</v-icon>
            </v-btn> -->
          </template>
          <v-list>
            <template v-if="dragSelected">
              <v-list-item
                @click="$emit('convertToCard', { text: getText(), groupSelected: true })"
              >
                <v-list-item-icon><v-icon>add_to_photos</v-icon></v-list-item-icon>
                <v-list-item-title>Group notes in new page</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="">
                <v-list-item-icon><v-icon>close</v-icon></v-list-item-icon>
                <v-list-item-title>Delete Selected Notes</v-list-item-title>
              </v-list-item>
            </template>
            <template v-else-if="note.type == 'card'">
              <v-list-item ref="firstMenu" @click="$emit('popNoteBlock', { noteId: note.id })">
                <v-list-item-icon><v-icon>settings_ethernet</v-icon></v-list-item-icon>
                <v-list-item-title>Pop Page</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="$emit('removeNoteBlock', { noteId: note.id })">
                <v-list-item-icon><v-icon>close</v-icon></v-list-item-icon>
                <v-list-item-title>Delete Note</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('removeNotePages', { noteId: note.id })">
                <v-list-item-icon><v-icon color="red">delete</v-icon></v-list-item-icon>
                <v-list-item-title>Delete Note & All Embedded Pages</v-list-item-title>
              </v-list-item>
            </template>
            <template v-else-if="note.type == 'note'">
              <v-list-item ref="firstMenu" @click="$emit('convertToCard', { text: getText() })">
                <v-list-item-icon class="mr-2"
                  ><v-icon small>insert_drive_file</v-icon></v-list-item-icon
                >
                <v-list-item-content>
                  <v-list-item-title>Convert to Page</v-list-item-title>
                </v-list-item-content>
                <shortcut-icon class="pl-2" size="10" :keys="['Ctrl', 'Enter']"></shortcut-icon>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="noteFormat = 1">
                <v-list-item-icon class="mr-2">
                  <span style="font-weight: 800; font-size: 0.8em; font-family: arial;">
                    H1
                  </span>
                </v-list-item-icon>
                <v-list-item-title>Convert to H1</v-list-item-title>
              </v-list-item>
              <v-list-item @click="noteFormat = 2">
                <v-list-item-icon class="mr-2">
                  <span style="font-weight: 800; font-size: 0.8em; font-family: arial;">
                    H1
                  </span>
                </v-list-item-icon>
                <v-list-item-title>Convert to H2</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="$emit('removeNoteBlock', { noteId: note.id })">
                <v-list-item-icon class="mr-2"><v-icon small>close</v-icon></v-list-item-icon>
                <v-list-item-title>Delete Note Block</v-list-item-title>
              </v-list-item>
            </template>
            <template v-else-if="note.type == 'widget'">
              <v-list-item ref="firstMenu" @click="$emit('toggleShowSource', { text: getText() })">
                <v-list-item-icon class="mr-2">
                  <v-icon small>format_quote</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-if="note.showSource">Hide Source</v-list-item-title>
                  <v-list-item-title v-else>Show Source</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="$emit('removeNoteBlock', { noteId: note.id })">
                <v-list-item-icon class="mr-2"><v-icon small>close</v-icon></v-list-item-icon>
                <v-list-item-title>Delete Note Block</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>

        <template v-if="note.type == 'note'">
          <div v-if="!userCanEdit || (slowLoad && !editorReady)" class="ql-container pr-6">
            <div class="ql-editor" style="overflow-wrap: anywhere;" v-html="noteHtml.html"></div>
          </div>
          <content-editor
            v-else
            v-model="noteHtml"
            class="pr-6"
            ref="editor"
            :key="note.id"
            :placeholder="onlyNote || lastNote || focused ? 'Add notes and research...' : ''"
            :disabled="dragging"
            highjackUndo
            :hijackCopy="dragSelected"
            :hijackPaste="false"
            allowFormats
            allowMarkdown
            :enableLink="true"
            :allowQuoteAttr="allowQuoteAttr"
            allowTraversal
            allowEnterMoveText
            @convertToCard="$emit('convertToCard', $event)"
            @keyEnter="$emit('addNewLine', { order: index + 1, delta: $event })"
            @keyDownLastLine="
              $emit('traverseBlocks', { toIndex: index + 1, direction: 'down', event: $event })
            "
            @keyUpFirstLine="$emit('traverseBlocks', { toIndex: index - 1, event: $event })"
            @keyBackspaceFirstChar="$emit('moveLineBack', { note: note, delta: $event })"
            @keyBackspaceEmpty="$emit('moveLineBack', { note: note, delta: $event })"
            @keyDeleteLastChar="$emit('moveNextLineBack', { note: note })"
            @keyLeftFirstChar="$emit('moveToLine', { toIndex: index - 1, direction: 'prev' })"
            @keyRightLastChar="$emit('moveToLine', { toIndex: index + 1, direction: 'next' })"
            @keyShiftTab="$emit('tabBack')"
            @undo="$emit('undo')"
            @redo="$emit('redo')"
            @copy="$emit('copyBlocks')"
            @focus="
              focused = true;
              setFocusedContainer(pageId);
            "
            @blur="focused = false"
            @paste="log('paste this')"
            @promptAttr="promptAttr"
            @slash="
              noteBlockMenu = true;
              $nextTick(() => $refs.firstMenu.$el.focus());
            "
          ></content-editor>
          <div
            v-show="focused && isEmpty"
            style="height: 26px; position: absolute; left: 0px; top: 100%; z-index: 10;"
          >
            <v-btn-toggle v-if="editorReady" v-model="noteFormat">
              <v-btn small value="1">
                <span style="font-weight: 800; font-size: 1.5em; font-family: arial;">H1</span>
              </v-btn>
              <v-btn small value="2">
                <span style="font-weight: 800; font-size: 1.5em; font-family: arial;">H2</span>
              </v-btn>
              <v-menu
                v-model="showEmbed"
                :close-on-content-click="false"
                nudge-left="150"
                max-height="400"
              >
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on">
                    Embed Research
                  </v-btn>
                </template>
                <v-card width="380">
                  <embed-resource-card
                    v-if="showEmbed"
                    @addResourceToPage="$emit('addNoteBlock', { ...$event, order: index })"
                  ></embed-resource-card>
                </v-card>
              </v-menu>
            </v-btn-toggle>
          </div>
          <div
            v-if="shortcuts.show"
            class=""
            :style="
              `position: absolute; 
              top: 0; 
              left: 0px;`
            "
          >
            <v-autocomplete
              autofocus
              class="pt-0 mt-0 white"
              @blur="shortcuts.show == false"
              value=""
              flat
              :items="[
                { name: 'Header 1' },
                { name: 'Header 2' },
                { name: 'Research' },
                { name: 'New Page' }
              ]"
              item-text="name"
              return-object
              @keydown.space.native="
                shortcuts.show = false;
                attrPrompt.cancel();
                $refs.editor.focus();
              "
              @keydown.esc.native="
                shortcuts.show = false;
                attrPrompt.cancel();
                $refs.editor.focus();
              "
              @change="attrPrompt.show = false"
            ></v-autocomplete>
          </div>
          <v-card
            v-if="promptToAdd.show"
            class="elevation-1 white px-1"
            :style="
              `position: absolute; 
              top: 25px;
              z-index: 1;`
            "
          >
            <v-row no-gutters>
              <v-col class="pa-0 strong" style="place-self: center;">Capture Webpage?</v-col>
              <v-col class="shrink pa-0">
                <v-btn icon @click="captureWebpage(promptToAdd.value)">
                  <v-icon color="primary">check_circle</v-icon>
                </v-btn>
              </v-col>
              <v-col class="shrink pa-0">
                <v-btn icon @click="promptToAdd = { show: false, value: '', adding: false }">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-col>
              <v-progress-linear v-if="promptToAdd.adding" indeterminate></v-progress-linear>
            </v-row>
          </v-card>
          <div
            v-if="attrPrompt.show"
            class="elevation-1"
            :style="
              `position: absolute; 
              top: 0; 
              left: ${attrPrompt.left}px;`
            "
          >
            <v-autocomplete
              autofocus
              label="Attribute to participant"
              :items="Object.values(participants)"
              item-text="name"
              return-object
              @keydown.space.native="
                attrPrompt.show = false;
                attrPrompt.cancel();
                $refs.editor.focus();
              "
              @keydown.esc.native="
                attrPrompt.show = false;
                attrPrompt.cancel();
                $refs.editor.focus();
              "
              @change="
                $emit('convertToQuote', { author: $event, note: note.id });
                attrPrompt.show = false;
              "
            ></v-autocomplete>
          </div>
          <div v-if="!dragSelected" :style="`position: absolute; right: 0px; top: 0px;`">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: onHover }">
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ on: onMenu }">
                    <v-fade-transition>
                      <v-btn
                        icon
                        v-on="{ ...onHover }"
                        @click="setResourceViewer({ show: true, resourceId: 'import', width: 33 })"
                        v-show="hovering"
                        outlined
                        class="grey lighten-5"
                        small
                        elevation="0"
                      >
                        <v-icon>library_add</v-icon>
                      </v-btn>
                    </v-fade-transition>
                  </template>
                  <add-resource-widget @created=""></add-resource-widget>
                </v-menu>

                <!-- <v-btn
                    v-show="hovering"
                    outlined
                    icon
                    class="grey lighten-5"
                    small
                    elevation="0"
                    @mouseenter="on.mouseenter"
                    @mouseleave="on.mouseleave"
                    @click="$emit('convertToCard', { text: getText() })"
                  >
                    <v-icon small>add</v-icon>
                  </v-btn> -->
              </template>
              <span>Add Resource</span>
              <!-- <shortcut-icon size="12" :keys="['+', 'Space']"></shortcut-icon> -->
            </v-tooltip>
          </div>
        </template>
        <template v-else-if="note.type == 'quote'">
          <v-layout>
            <user-avatar :avatarUrl="note.content.author.avatar"></user-avatar>
            <div
              v-if="!userCanEdit || (slowLoad && !editorReady)"
              v-html="noteHtml.html"
              class="ql-editor pl-4"
            ></div>
            <content-editor
              v-else
              class="pl-4"
              v-model="noteHtml"
              ref="editor"
              :key="note.id"
              :placeholder="onlyNote || focused ? 'Add a new note' : ''"
              :disabled="dragging"
              highjackUndo
              :hijackCopy="dragSelected"
              :hijackPaste="false"
              allowFormats
              allowMarkdown
              allowTraversal
              allowEnterMoveText
              @keyEnter="$emit('addNewLine', { order: note.order + 1, delta: $event })"
              @keyDownLastLine="
                $emit('traverseBlocks', {
                  toIndex: note.order + 1,
                  direction: 'down',
                  event: $event
                })
              "
              @keyUpFirstLine="$emit('traverseBlocks', { toIndex: note.order - 1, event: $event })"
              @keyBackspaceFirstChar="
                $emit('convertToNote', { notesLength: $event, noteId: note.id })
              "
              @keyBackspaceEmpty="$emit('removeNoteBlock', { noteId: note.id })"
              @keyDeleteLastChar="$emit('moveNextLineBack', { note: note })"
              @keyLeftFirstChar="
                $emit('moveToLine', { toIndex: note.order - 1, direction: 'prev' })
              "
              @keyRightLastChar="
                $emit('moveToLine', { toIndex: note.order + 1, direction: 'next' })
              "
              @keyShiftTab="$emit('tabBack')"
              @undo="$emit('undo')"
              @redo="$emit('redo')"
              @copy="$emit('copyBlocks')"
              @focus="focused = true"
              @blur="focused = false"
              @paste="log('paste this form noteblock')"
            ></content-editor>
          </v-layout>
          <div class="caption">{{ note.content.author.name }}</div>
        </template>
        <resource-card
          v-else-if="note.type == 'widget'"
          :blockData="{
            resource: widgetResource,
            excerpts: excerpts,
            showSource: note.showSource
          }"
          ref="widget"
          tabindex="0"
          blockType="note"
          @keyUp="$emit('traverseBlocks', { toIndex: index - 1, event: $event })"
          @keyDown="$emit('traverseBlocks', { toIndex: index + 1, event: $event })"
          @keyEnter="userCanEdit ? $emit('addNewLine', { order: note.order + 1 }) : null"
          @delete="userCanEdit ? $emit('removeNoteBlock', { noteId: note.id }) : null"
          @clicked="showPreview = true"
          @doubleClick="
            showPreview = false;
            setResourceViewer({ show: true, resourceId: widgetResource.id, width: 50 });
          "
          color="transparent"
        >
          <template v-slot="props" name="after">
            <div :style="`position: absolute; right: 10px;`" v-if="props.hover || showPreview">
              <v-menu v-model="showPreview" :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn icon small v-on="on">
                    <v-icon>more_horiz</v-icon>
                  </v-btn>
                </template>
                <resource-details-card
                  :resource="widgetResource"
                  showOpen
                  @close="showPreview = false"
                ></resource-details-card>
              </v-menu>
            </div>
          </template>
        </resource-card>
        <template v-else-if="note.type == 'card'">
          <embedded-card
            ref="embeddedCard"
            :userCanEdit="userCanEdit"
            :pageId="note.pageId"
            :parentNoteId="note.id"
            :parentPageId="pageId"
            :hovering="hovering"
            :focused="focused"
            :showDoc="show"
            :firstDragSelected="firstDragSelected"
            :dragSelected="dragSelected"
            :editorReady="editorReady"
            @blur="focused = false"
            @focus="
              focused = true;
              $nextTick(() => {
                setFocusedContainer(note.pageId);
              });
            "
            @keyBackspaceEmpty="
              log('convert');
              $emit('convertToNote', $event);
            "
            :selectedNoteBlocks="selectedNoteBlocks"
            @addNewLineBelow="$emit('addNewLine', { ...$event, order: index + 1, type: 'card' })"
            @traverseLeaveUp="$emit('traverseBlocks', { toIndex: index - 1, event: $event })"
            @traverseLeaveDown="
              $emit('traverseBlocks', { toIndex: index + 1, event: $event, direction: 'down' })
            "
            @updateSelectedNotes="$emit('updateSelectedNotes', $event)"
            @updateSelectedNotesPage="$emit('updateSelectedNotesPage', $event)"
            @clearDragSelection="$emit('clearDragSelection')"
            @setShow="show = $event"
          >
          </embedded-card>
        </template>
        <!-- <div v-if="dragSelected" :style="`position: absolute; right: 0px; top: 0px;`">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-fade-transition>
                <v-btn
                  v-show="hovering"
                  outlined
                  icon
                  class="grey lighten-5"
                  small
                  elevation="0"
                  @mouseenter="on.mouseenter"
                  @mouseleave="on.mouseleave"
                  @click=""
                >
                  <v-icon small>add_to_photos</v-icon>
                </v-btn>
              </v-fade-transition>
            </template>
            <span>Group all in Page</span>
            <shortcut-icon size="12" :keys="['Ctrl', 'Enter']"></shortcut-icon>
          </v-tooltip>
        </div> -->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ContentEditor from '../ContentEditor';
import NoteBlockDropHelper from './NoteBlockDropHelper';
import UserAvatar from '../UserAvatar';
import ResourceCard from '@/components/Resources/ResourceCard';
import ResourcesPage from '@/views/Context/components/ResourcePanel/ResourcesPage';
import ResourceDetailsCard from '@/components/Resources/ResourceDetailsCard';
import EmbedResourceCard from '@/views/Context/components/EmbedResourceCard';
import SubNoteBlock from './SubNoteBlock';
import EmbeddedCard from './EmbeddedCard';
import AddResourceWidget from '@/components/Resources/AddResourceWidget';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { setTimeout } from 'timers';

export default {
  data() {
    return {
      hovering: false,
      editorReady: false,
      dragSelectEvent: false,
      focused: false,
      attrPrompt: { show: false, left: 0, top: 0 },
      shortcuts: { show: false, left: 0, top: 0 },
      showPreview: false,
      showEmbed: false,
      showAttach: false,
      showSubNotes: false,
      show: false,
      noteBlockMenu: false,
      promptToAdd: { show: false, value: '', adding: false }
    };
  },
  props: [
    'note',
    'pageNotes',
    'nestedNotes',
    'pageId',
    'index',
    'slowLoad',
    'dragSelected',
    'dragSelecting',
    'selectedNoteBlocks',
    'onlyNote',
    'lastNote',
    'allowQuoteAttr',
    'participants',
    'docNotes'
  ],
  components: {
    ContentEditor,
    NoteBlockDropHelper,
    ResourceCard,
    UserAvatar,
    EmbedResourceCard,
    ResourceDetailsCard,
    SubNoteBlock,
    EmbeddedCard,
    AddResourceWidget
  },
  mounted() {
    this.show = this.note.open;
    if (this.slowLoad) {
      setTimeout(() => {
        this.editorReady = true;
      }, 10 * (this.index + 1));
    } else {
      this.editorReady = true;
    }
  },
  destroyed() {
    document.removeEventListener('paste', this.handlePaste);
  },
  watch: {
    focused(val) {
      if (val) {
        //  setup a paste listener on focus
        console.log('add paste listener');
        document.addEventListener('paste', this.handlePaste);
      } else {
        //remove paste listener on blur
        console.log('remove paste listener');
        document.removeEventListener('paste', this.handlePaste);
        this.promptToAdd.show = false;
      }
    },
    focusedContainer(val) {
      if (val == this.note.id) {
        //  focus
        console.log('focus');
        this.$vuetify.goTo(this.$el, { container: '#notepage-container' });
      }
    },
    show(v) {
      if (v != this.openNotes[this.note.id]) {
        this.setNoteOpen({ noteId: this.note.id, value: v, pageId: this.pageId });
        // this.setOpenNotes({ noteId: this.note.id, val: v });
      }
    },
    openNoteStatus(v) {
      if (v != this.show) {
        this.show = v;
      }
    }
  },
  computed: {
    ...mapState('views/context', ['selectedPageId', 'animating', 'openNotes', 'focusedContainer']),
    ...mapGetters('context', ['userCanEdit']),
    // ...mapState('components/notepad', ['clipboard']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('components/dragdrop', ['draggedData']),
    ...mapState('resources', ['resources']),
    ...mapState('components/magicClipboard', ['clipboard']),
    noteHtml: {
      get() {
        return {
          html: this.note.content.html,
          updatedOn: this.note.updatedOn
        };
      },
      set(v) {
        this.$emit('updateNoteBlockHTML', {
          noteId: this.note.id,
          html: v
        });
        // this.updateNoteBlockHTML({
        //   pageId: this.selectedPageId,
        //   noteBlockId: this.note.id,
        //   html: v
        // });
      }
    },
    shortcutsSearch: {
      get() {
        return this.noteHtml.html;
      },
      set(v) {
        this.noteHtml = v;
      }
    },
    noteFormat: {
      get() {
        return false;
        // console.log(this.$refs.editor.getFormat());
        // const formats = this.$refs.editor.getFormat();
        // if (formats.header) {
        //   return formats.header;
        // } else {
        //   return 'p';
        // }
      },
      set(format) {
        console.log('set', format);
        const formats = this.$refs.editor.getFormat();
        if (formats.header && formats.header == format) {
          this.$refs.editor.formatLine('p');
        } else {
          this.$refs.editor.formatLine(format);
        }
      }
    },
    openNoteStatus() {
      return this.openNotes[this.note.id];
    },
    firstDragSelected() {
      return this.dragSelected && this.selectedNoteBlocks[0] == this.note.id;
    },
    isEmpty() {
      if (this.noteHtml.html) {
        console.log(this.$refs.editor.editor.getLength() <= 1);
        return this.$refs.editor.editor.getLength() <= 1;
      } else {
        console.log('no notehtml');
        return true;
      }
    },
    blockType() {
      try {
        const firstTag = this.noteHtml.html.split('>')[0];
        const tag = firstTag.slice(1).toLowerCase();
        return tag.length ? tag : null;
      } catch (e) {
        return null;
      }
    },
    widgetResource() {
      return this.note.type == 'widget' && this.note.content.widgetType == 'resource'
        ? this.resources[this.note.content.widgetData.resourceId]
        : false;
    },
    isDraggingSelf() {
      return this.dragging && this.draggedData.ids.includes(this.note.id);
    },
    excerpts() {
      if (this.note.content.widgetData.resourceNoteIds) {
        return this.note.content.widgetData.resourceNoteIds.map(e =>
          this.widgetResource ? this.widgetResource.noteBlocks[e] : []
        );
      } else {
        return [];
      }
    }
  },
  methods: {
    ...mapMutations('views/context', [
      'setShowResourcePanel',
      'setResourcePanelView',
      'setResourceViewer',
      'setOpenNotes',
      'setFocusedContainer'
    ]),
    ...mapMutations('components/magicClipboard', ['resetClipboard']),
    ...mapActions('resources', ['createNewResource']),
    ...mapActions('pages', ['setNoteOpen']),
    log(x) {
      console.log(x);
    },
    captureWebpage(url) {
      this.promptToAdd.adding = true;
      console.log('capture webpage');
      setTimeout(() => {
        this.createNewResource({ type: 'webpage', url })
          .then(id => {
            console.log('created resource', id);
            const resourceData = {
              pageId: this.pageId,
              order: this.note.order + 1,
              html: false,
              widgetInfo: {
                widgetType: 'resource',
                widgetData: {
                  resourceId: id,
                  resourceVersion: 1,
                  resourceNoteIds: []
                }
              }
            };
            this.setResourceViewer({ show: true, resourceId: id, width: 50 });
            this.promptToAdd.adding = false;
            this.promptToAdd.show = false;
            this.$emit('addNoteBlock', resourceData);
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
          });
      }, 2);
    },
    focus() {
      if (this.note.type == 'note') {
        this.$refs.editor.focus();
      } else if (this.note.type == 'widget') {
        this.$refs.widget.$el.focus();
      } else if (this.note.type == 'card') {
        this.$refs.embeddedCard.traverseIn({ prevLeft: 0, direction: 'down' });
      }
    },
    openResource() {
      this.setResourcePanelView(this.widgetResource.id);
      this.setShowResourcePanel(true);
    },
    checkIfUrl(url) {
      //  Check if this is a URL we are pasting
      console.log('check valid url');
      const validURL = function(str) {
        var pattern = new RegExp(
          '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$',
          'i'
        ); // fragment locator
        return !!pattern.test(str);
      };

      if (validURL(url)) {
        console.log('is valid');
        this.promptToAdd = { show: true, value: url };
      }
    },
    handlePaste(event) {
      //  check magic clipboard
      const pasteText = event.clipboardData.getData('text');
      console.log(event);
      console.log(pasteText);
      console.log(this.clipboard);
      //  using contents and parent here for future use when copying resources
      const { text } = this.clipboard;
      console.log(pasteText);
      console.log(text);
      try {
        const pasteTextClean = pasteText.replace(/\r?\n|\r/g, '~=');
        const textClean = text.replace(/\r?\n|\r/g, '~=');
        console.log(pasteTextClean, textClean);
        if (pasteTextClean == textClean) {
          event.preventDefault();
          this.$emit('pasteBlocks');
          console.log('paste from magic clipboard');
        } else {
          //  we're pasting soething else. clear our coppiedBlocks
          if (this.clipboard.text != null) {
            this.resetClipboard();
            //this.setClipboard({ text: null, blockIds: [] });
          }
          this.checkIfUrl(pasteText);
          return true;
        }
      } catch (e) {
        this.checkIfUrl(pasteText);
        return true;
      }
    },
    handleMouseLeave() {
      if (this.dragSelectEvent && !this.dragSelecting && this.userCanEdit) {
        console.log('start drag select');
        //  We have dragged outside the block, switch to dragSelect mode
        this.$emit('startDragSelect', this.dragSelectEvent);
        //  focus on this block
        window.addEventListener('mouseup', this.stopDragSelect);
      }
      if (this.hovering) {
        this.hovering = false;
      }
    },
    testDragSelectStart(e) {
      console.log('start');
      if (this.userCanEdit) {
        this.dragSelectEvent = e;
      }
    },
    stopDragSelect() {
      if (this.dragSelectEvent) {
        //  stop drag
        this.dragSelectEvent = false;
        window.removeEventListener('mouseup', this.stopDragSelect);
      }
    },
    // async addNewLine(delta) {
    //   const order = this.note.order + 1;
    //   this.$emit('addNewLine', { order, html: '' });
    //   //  update order of all higher up notes
    //   //  new vuex note here, returns id
    //   // const newId = await this.addNoteBlock({
    //   //   html: '',
    //   //   order: newIndex,
    //   //   pageId: this.selectedPageId
    //   // });

    //   // this.$nextTick(() => {
    //   //   if (delta) {
    //   //     this.$emit('setNoteContent', { noteId: newId, delta: delta });
    //   //     //this.$refs['note' + newId][0].setContents(delta);
    //   //   }
    //   //   this.$emit('focusNoteBlock', { noteId: newId });
    //   //   //  this.$refs['note' + newId][0].focus();
    //   // });
    // },
    getContents() {
      return this.$refs.editor ? this.$refs.editor.editor.getContents() : '';
    },
    getText() {
      console.log('getText');
      return this.$refs.editor ? this.$refs.editor.editor.getText() : '';
    },
    promptAttr({ pos, cancel }) {
      console.log(pos, this.$el);
      this.attrPrompt = {
        show: true,
        left: pos[0].left - this.$el.offsetWidth,
        cancel() {
          return cancel();
        }
      };
    },
    dragStart(event) {
      const ids = [this.note.id];
      const element = this.$el;
      const shift = {
        x: event.clientX - element.getBoundingClientRect().left,
        y: event.clientY - element.getBoundingClientRect().top
      };
      this.$emit('dragStart', { event, ids, element, shift });
    },
    setShow(v) {
      this.show = v;
    }
  }
};
</script>

<style>
.noteBlock {
  margin-bottom: 1px;
  padding-bottom: 4px;
  min-height: 28px;
}

.noteBlock .ql-editor p {
  font-size: 16px;
  margin-bottom: 0px;
}

.noteBlock .ql-editor h1 {
  font-size: 1.3em !important;
  /* padding-bottom: 14px; */
  /* margin-top: 20px; */
  font-weight: 500;
  line-height: 1.5em;
}

.noteBlock .ql-editor h2 {
  font-weight: 500;
  font-size: 1.1em;
  margin-top: 0px;
}

.dragging .h1-block.first-block {
  margin-top: 0px;
  padding-top: 0px !important;
}

.h1-block {
  margin-top: 20px;
  margin-bottom: 2px;
}

.h1-block.first-block {
  margin-top: 0px;
  margin-bottom: 2px;
}

.dragging .h1-block {
  margin-top: 0px;
  padding-top: 20px !important;
}

.h2-block {
  margin-top: 2px;
}

.dragging .h2-block.first-block {
  margin-top: 0px;
  padding-top: 0px !important;
}

.dragging .h2-block {
  margin-top: 0px;
  padding-top: 2px !important;
}

.dragged {
  background: #e9e9e9;
}
</style>
